
import { useCallback } from 'react';
import { TextField, Tooltip} from '@mui/material';

import { useStepValidator } from 'Hooks/useStepValidator';
import { INPUT_STEP_NAMES } from 'Pages/Inputs/constants';
import { useInputStore } from 'Store';

export const EmptyDate = ({ min_date = '', max_date = '' }) => {
    const date_empty = useInputStore(state => state.date_empty)
    const setValue = useInputStore((state) => state.set_value)

    // validation
    const isValidEmptyDate = useCallback(() => {
      const date = new Date(date_empty)
      const min = new Date(min_date)
      const max = new Date(max_date)

      // is valid date && between the simulation start and end dates 
      return !isNaN(date) && date >= min && date <= max
    }, [date_empty, min_date, max_date])

    useStepValidator(INPUT_STEP_NAMES.empty, 'date_empty', () => isValidEmptyDate(date_empty, min_date, max_date));
    
    const handleChange = (event) => {
      setValue({ 'date_empty': event.target.value})
    }

    const minDateFormatted = new Date(min_date).toLocaleDateString('en-GB')
    const maxDateFormatted = new Date(max_date).toLocaleDateString('en-GB')
    
    return (
      <Tooltip title={`In the simulation period (${minDateFormatted} - ${maxDateFormatted}), when do you want to empty the slurry storage?`}>
        <TextField
          size='small'
          label='Empty Date'
          type='date'
          InputLabelProps={{
            shrink: true,
          }}
          inputProps={{ min: min_date, max: max_date }}
          value={date_empty}
          onChange={handleChange}
          error={!isValidEmptyDate()}
          helperText={!isValidEmptyDate() ? `Please select a valid date within the simulation dates (${minDateFormatted} - ${maxDateFormatted})` : ''}
        />
      </Tooltip>
    )
  }
